import { useNavigate } from "react-router-dom";
import {
  Col,
  Row,
  Button
} from 'react-bootstrap';
//components
import {
  FaHome, FaShoppingCart,
  FaUserAlt, FaCogs
} from "react-icons/fa";
import Crumbs from '../../components/Crumbs'

import ProtectedAccess  from '../../components/ProtectedAccess'

//styles
import './style.css';
import { useAppStore } from "../../context/state";
// import { PermissionsGate } from "../../permissions/PermissionGate";

const  Header =({changeLanguage, lang }) =>{
  // state
  const cart = useAppStore((state) => state.shopingCart)
  const user = useAppStore((state) => state.user)

  const navigate = useNavigate();
  const quantity =cart.length

  return (
      <section className="">
        {//<Crumbs changeLanguage={changeLanguage} lang={lang}/>
}
        <Row >
          <Col sm={12} md={7} className="page-title">
            <h2>
            <a href="/editorial/">
              <span>Editorial</span> Facultad de Humanidades
            </a>  
            </h2>
          </Col>        
          <Col sm={12} md={5} className="ml-auto text-right d-none d-md-block">
            {/* <Button className="p-2" variant="outline-secondary" onClick={() => navigate("/editorial/")}>
              <FaHome size={20} /> {' '}
            </Button>{' '}
            <span >
              <Button className="p-2  position-relative" variant="outline-secondary" onClick={() => navigate('/editorial/shopping-cart')}>
                <FaShoppingCart size={20} /> {' '} 
                 
                <ProtectedAccess 
                  element={
                    lang.btn_shopping_cart
                  }
                  role={['any']}
                  lang={lang}
                />{' '} 
                
                                
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {quantity}
                </span>
              </Button>{' '}
            </span> */}
            <ProtectedAccess 
              element={
                <Button className="p-2" variant="outline-danger" onClick={() => navigate("/editorial/control-panel")}>
                    <FaCogs size={20} />{' '}{lang.btn_control_panel}
                </Button>
              }
              role={['admin', 'editor']}
              lang={lang}
            />{' '} 
            <Button className="p-2" variant="outline-secondary" onClick={() => navigate("/editorial/user-access")}>
                { user && user.firstName ? user.firstName: lang.btn_account } {' '} <FaUserAlt size={20} /> 
            </Button>{' '}
          </Col>
        </Row>
      </section>
  );
}

export default Header;
